/* GENERATED with v0.0.117 of https://github.beeone.at/George/ibo
 * FROM v1.48.4 of "Products"
 * CHANGES WILL BE LOST, DO NOT MAKE MANUAL CHANGES
 */
/* istanbul ignore file */
/* eslint-disable */
import type { GetProductsResponse } from '../models/GetProductsResponse';
import type { ProductCategory } from '../models/ProductCategory';
import type { ProductType } from '../models/ProductType';

import { clientOptionsFactory } from '../clientOptions';
import { apiClientRequest as __request } from '@api-client/base';
import type { ClientOptions } from '@api-client/base';

export class AggregationService {

    /**
     * (Beta) List all products
     * Lists all products of a user with their common attributes.
     * The products are ordered as the client should display them. Defaulting to customization sort order.
     *
     * @returns GetProductsResponse Example response
     * @throws ApiError
     */
    public static getPublicProducts({
        id,
        category,
        type,
        label,
        favorite,
        sort,
        page,
        size,
    }: {
        /**
         * Return only Products with provided IDs
         *
         */
        id?: Array<string>,
        /**
         * Filter to display only products of given `category`. See [Product Categories](#section/Product-Categories) for possible values.
         *
         */
        category?: Array<ProductCategory>,
        /**
         * Filter to display only products of given `type`. Possible types are dependant on the `category`.
         * See [Product Categories](#section/Product-Categories) for details.
         *
         */
        type?: Array<ProductType>,
        /**
         * Filter to display only products that are customized with the given `label`.
         * Parameter escaping is applied (see "Filter parameter escaping").
         *
         */
        label?: Array<string>,
        /**
         * Filter to display only favorite products.
         *
         */
        favorite?: boolean,
        /**
         * **Not implemented**\
         * Sort criteria, can be any field in ascending or descending order. Format: `<field>[,desc|asc]`
         *
         */
        sort?: string,
        /**
         * The requested page number, zero based
         */
        page?: number,
        /**
         * The requested page size
         */
        size?: number
    },
    clientOptionsOverride: { skipParseJSON: true } & Partial<ClientOptions>): Promise<Response>;
    public static getPublicProducts({
        id,
        category,
        type,
        label,
        favorite,
        sort,
        page,
        size,
    }: {
        /**
         * Return only Products with provided IDs
         *
         */
        id?: Array<string>,
        /**
         * Filter to display only products of given `category`. See [Product Categories](#section/Product-Categories) for possible values.
         *
         */
        category?: Array<ProductCategory>,
        /**
         * Filter to display only products of given `type`. Possible types are dependant on the `category`.
         * See [Product Categories](#section/Product-Categories) for details.
         *
         */
        type?: Array<ProductType>,
        /**
         * Filter to display only products that are customized with the given `label`.
         * Parameter escaping is applied (see "Filter parameter escaping").
         *
         */
        label?: Array<string>,
        /**
         * Filter to display only favorite products.
         *
         */
        favorite?: boolean,
        /**
         * **Not implemented**\
         * Sort criteria, can be any field in ascending or descending order. Format: `<field>[,desc|asc]`
         *
         */
        sort?: string,
        /**
         * The requested page number, zero based
         */
        page?: number,
        /**
         * The requested page size
         */
        size?: number
    },
    clientOptionsOverride?: Partial<ClientOptions>): Promise<GetProductsResponse>;
    public static getPublicProducts({
        id,
        category,
        type,
        label,
        favorite,
        sort,
        page,
        size
    }: {
        /**
         * Return only Products with provided IDs
         *
         */
        id?: Array<string>,
        /**
         * Filter to display only products of given `category`. See [Product Categories](#section/Product-Categories) for possible values.
         *
         */
        category?: Array<ProductCategory>,
        /**
         * Filter to display only products of given `type`. Possible types are dependant on the `category`.
         * See [Product Categories](#section/Product-Categories) for details.
         *
         */
        type?: Array<ProductType>,
        /**
         * Filter to display only products that are customized with the given `label`.
         * Parameter escaping is applied (see "Filter parameter escaping").
         *
         */
        label?: Array<string>,
        /**
         * Filter to display only favorite products.
         *
         */
        favorite?: boolean,
        /**
         * **Not implemented**\
         * Sort criteria, can be any field in ascending or descending order. Format: `<field>[,desc|asc]`
         *
         */
        sort?: string,
        /**
         * The requested page number, zero based
         */
        page?: number,
        /**
         * The requested page size
         */
        size?: number,
    },
    clientOptionsOverride: Partial<ClientOptions> = {}
) {
    return __request(
        {...clientOptionsFactory.get()(), ...clientOptionsOverride},
        {
            method: 'GET',
            url: '/public/products',
            query: {
                'id': id,
                'category': category,
                'type': type,
                'label': label,
                'favorite': favorite,
                'sort': sort,
                'page': page,
                'size': size,
            },
            headers: {
                'accept': 'application/hal+json',
            },
        });
    }

}
